export default {
    "audio.title": "Résumés Audio",
    "audio.subtitle": "Apprenez en écoutant nos résumés détaillés de chaque chapitre.",
    "audio.status.finished": "Terminé",
    "audio.status.listening_now": "En cours d'écoute",
    "audio.status.playing": "Lecture en cours",
    "audio.status.no_audios": "Aucun fichier audio disponible pour le moment.",
    "audio.premium.title": "Accédez à tous les audioguides",
    "audio.premium.description": "Débloquez la bibliothèque complète des résumés audio pour réviser partout, même sans écran.",
    "audio.premium.cta": "Passer au Premium"
};
